import React from 'react';
import styled from 'styled-components';
import { translate } from '../../common/translation/translate';
import { ErrorBoundaryIcon } from '../common/errorBoundary/errorBoundaryIcon';

export const WidgetErrorUI = () : JSX.Element => {
    return (
        <Container>
            <IconWrapper>
                <ErrorBoundaryIcon fillColor='#8E8E93'/>
            </IconWrapper>
            <NoDataText isTitle={true}>{translate('failedToLoad')}</NoDataText>
            <NoDataDescriptionWrapper>
                <NoDataText >{translate('dataLoadFirstErrorMessage')}</NoDataText>
                <NoDataText >{translate('dataLoadSecondErrorMessage')}</NoDataText>
            </NoDataDescriptionWrapper>
        </Container>
    );
};
interface SlimWidgetErrorUIProps {
    children?: JSX.Element;
}

export const SlimWidgetErrorUI = ({ children } : SlimWidgetErrorUIProps) : JSX.Element => {
    return (
        <SlimContainer>
            <IconWrapper>
                <ErrorBoundaryIcon fillColor='#8E8E93'/>
            </IconWrapper>
            <SlimDataWrapper>
                <NoDataText isTitle={true} isSlimTitle>{translate('failedToLoad')}</NoDataText>
                <TextDescriptionAndChildrenWrapper>
                    <ErrorDescriptionText>{translate('dataLoadErrorMessage')}.</ErrorDescriptionText>
                    {children}
                </TextDescriptionAndChildrenWrapper>
            </SlimDataWrapper>
        </SlimContainer>
    );
};

const TextDescriptionAndChildrenWrapper =styled.div`
    display:flex;
    flex-direction:row;
    justify-content:end;
`;

const SlimContainer = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
    justify-content:center;
    padding: 16px;
    background-color: #f9f9f9;
    width:100%;
    gap:10px;
    height:inherit;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 12px 10px;
    background: #f9f9f9;
    justify-content: center;
    align-items:center;
    width: 100%;
    gap: 12px;
    height: 100%;
`;
const IconWrapper = styled.span`
    display: flex;
    flex-direction: column;
    background: rgba(142, 142, 147, 0.1);
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    width: 48px;
    height: 48px;
    padding: 8px;
`;

interface NoDataTextProps {
    isTitle?: boolean;
    isSlimTitle?: boolean;
}

const NoDataText = styled.div<NoDataTextProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    ${({ isSlimTitle })=> !isSlimTitle && `
        justify-content: center;
    `}
    font-family: Source Sans Pro;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    font-weight: ${({ isTitle }) => isTitle ? '600' : 'normal' };
`;

const ErrorDescriptionText = styled.div`
    display: -webkit-box;
    overflow:hidden;
    text-align:start;
    -webkit-line-clamp:2;
    text-overflow:ellipsis;
    -webkit-box-orient: vertical;
    font-family: Source Sans Pro;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    font-weight: normal;
`;

const NoDataDescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
const SlimDataWrapper = styled.div`
    display:flex;
    gap:10px;
    height:70px;
    flex-direction:column;
    justify-content:start;
    
`;